import React from 'react'
import ReactDOM from 'react-dom'
import * as Analytics from './helpers/analytics'

import App from './App'

Analytics.initialize()

ReactDOM.render(<App />, document.getElementById('root'))
